module.exports = __webpack_public_path__ + "58d5afee1bf1f580c8a5c89d85c54a81.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/news1.jpg
// module id = 196
// module chunks = 0